export const PR2_UNIT_NAMES = ['Unit4', 'Unit5', 'Unit6', 'Unit10', 'Unit11', 'Unit12'];

export function getPeriodFromMinStartTime(state, groupId) {
  const overview = state.get('rootReducer').get('progressTestOverview').get(groupId);
  if (!overview || !overview.data) return null;

  const progressTests = overview.data;
  let earliestStartTime = null;

  progressTests.forEach((progressTest) => {
    const units = progressTest.get('units');
    if (!units) return;

    units.forEach((unit) => {
      const unitName = unit.get('unitName');
      if (!PR2_UNIT_NAMES.includes(unitName)) return;

      const sessions = unit.get('sessions');
      if (!sessions) return;

      sessions.forEach((session) => {
        const startTime = session.get('startTime');
        if (!startTime) return;
        if (!earliestStartTime || startTime < earliestStartTime) {
          earliestStartTime = startTime;
        }
      });
    });
  });
  
  return earliestStartTime;
}



// WEBPACK FOOTER //
// ./data/ProgressTestOverview/accessors.js